export enum MimeTypeEnum {
  XLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  OCTET_STREAM = 'application/octet-stream',
}
